import { PaletteColor, Theme } from '@mui/material'
import { makeStyles } from '@mui/styles'
import { getRGBA } from 'utils/color'

const useStyles = makeStyles((theme: Theme) => ({
  header: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',

    '& h6': {
      margin: 0,
      padding: 0,
      font: 'Sora',
      fontSize: '1.25rem',
      lineHeigth: '2rem',
      fontWeight: '600',
    },
  },

  subHeader: {
    display: 'flex',
    flexDirection: 'row',

    '& span': {
      fontFamily: 'Nunito',
      fontSize: '1rem',
      lineHeigth: '2.75rem',
      fontWeight: '400',
    },

    '& a': {
      color: '#3024E1 !important',
    },
  },

  closeBtn: {
    cursor: 'pointer',
    transition: 'all 300ms ease-in-out',

    '&:hover': {
      color: (theme.palette.anger as PaletteColor).main,
    },
  },

  title: {
    display: 'flex',
    flexDirection: 'row',
    gap: '0.5rem',
  },

  tooltip: {
    display: 'flex',
    flexDirection: 'column',
    gap: '0.15rem',

    '& ul': {
      margin: '0 !important',
      padding: '0 !important',
      marginLeft: '1rem !important',
    },

    '& span, & li': {
      fontFamily: 'Nunito !important',
      fontWeight: '600 !important',
      fontSize: '0.7rem !important',
      color: '#FFFFFF !important',
      margin: '0 !important',
      padding: '0 !important',
    },
  },

  tooltipIcon: {
    marginTop: '0.2rem',
    cursor: 'pointer',
  },

  downloadButton: {
    display: 'flex',
    flexDirection: 'row',
    gap: '0.3rem',
    height: '2.25rem !important',
    padding: '1rem 0.5rem !important',
    margin: '1.25rem 0 !important',
  },

  uploadArea: {
    height: '150px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    gap: '0.25rem',
    cursor: 'pointer',
    marginBottom: '1.5rem',
    borderRadius: '0.33rem',
    border: '2px dashed #3024E1',
    backgroundColor: '#FFFFFF',
    transition: 'all 200ms ease',

    '& .MuiSvgIcon-root': {
      fontSize: '1.5rem !important',
      color: '#3024E1',
    },

    '&:hover': {
      backgroundColor: getRGBA(' #3024E1', 0.04),
    },
  },

  uploadAreaTextSend: {
    padding: '0 !important',
    margin: '0 !important',
    fontFamily: 'Nunito',
    fontSize: '1rem !important',
    fontWeight: '400 !important',
    lineHeight: '1.5rem !important',
    color: '#3024E1',
  },

  uploadAreaTextInfo: {
    fontFamily: 'Nunito',
    fontSize: '0.8rem !important',
    fontWeight: '400 !important',
    lineHeight: '1.245rem !important',
    color: getRGBA('#0F0F1E', 0.6),
  },

  alertBox: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-start',
    gap: '0.75rem',
    padding: '0.5rem 1rem',
    borderRadius: '0.5rem',
    backgroundColor: '#EDF7ED',
  },

  alertText: {
    width: '100vw',
    display: 'flex',
    flexDirection: 'column',
    gap: '0.25rem',

    '& strong': {
      color: '#1E4620',
      fontFamily: 'Sora',
      fontWeight: '600',
      fontSize: '1rem',
      lineHeight: '1.5rem',
    },

    '& span': {
      fontFamily: 'Nunito',
      fontWeight: '600 !important',
      fontSize: '0.875rem',
      lineHeight: '1.25rem',
      color: '#191C1A !important',
    },

    '& a': {
      color: '#3024E1 !important',
      fontWeight: '700 !important',
    },
  },

  alertClose: {
    cursor: 'pointer',

    '& .MuiSvgIcon-root': {
      color: '#1E4620',
    },
  },

  uploadFiles: {
    maxHeight: '450px',
    overflowY: 'scroll',

    '& strong': {
      fontFamily: 'Nunito',
      fontSize: '1rem',
      fontWeight: '700',
      lineHeight: '1.5rem',
      color: '#191C1A',
    },
  },

  uploadFilesContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '0.5rem',
    margin: '1.5rem 0',
  },

  uploadFileItem: {
    width: '100%',
    borderRadius: '0.5rem',
    backgroundColor: theme.palette.primary.contrastText,

    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: '0 0.25rem',

    '& .MuiSvgIcon-root': {
      color: '#C4C4C4',
      fontSize: '2rem',
      cursor: 'pointer',
    },
  },

  uploadFileItemContent: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-start',
    gap: '1rem',
    width: '100%',

    '& span': {
      fontFamily: 'Nunito',
      fontSize: '1rem',
      fontWeiht: '400',
      lineClamp: 1,
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      display: '-webkit-box',
      WebkitLineClamp: 1,
      WebkitBoxOrient: 'vertical',
    },
  },

  uploadFileItemArticleIcon: {
    fontSize: '1.6rem !important',
    color: '#1C1B1F !important',
  },

  uploadFileItemDeleteIcon: {
    color: '#DE3730 !important',
    fontSize: '1.6rem !important',
    cursor: 'pointer',
  },

  actions: {
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-start',
    justifyContent: 'flex-end',
    gap: '0.5rem',
    paddingTop: '1.5rem',
  },

  submitButton: {
    height: '2.25rem !important',
    padding: '1rem !important',
  },

  cancelButton: {
    height: '2.25rem !important',
    padding: '1rem !important',
    color: '#BA1A1A !important',
    border: `1px solid ${getRGBA('#BA1A1A', 0.5)} !important`,
  },
}))

export { useStyles }
